// extracted by mini-css-extract-plugin
module.exports = {"map":"DesignMap_map__1V895","wrapper":"DesignMap_wrapper__3zEW3","frame":"DesignMap_frame__pQkJH","fade-out":"DesignMap_fade-out__2Mi8s"};